import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-terms-and-conditions-pe',
  templateUrl: './terms-and-conditions-pe.component.html',
  styleUrls: ['./terms-and-conditions-pe.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TermsAndConditionsPeComponent {

  constructor() { }

}
